    export const data = [

        {
          id: 1,
          name: "Barry Allen",
          description: "Me + You +… JK, You Don’t Have to Do Any Math to Send Me a Message!",
          age: 30,
          image: "https://images.unsplash.com/photo-1583854608682-94147497bd27?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fGNvYXR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
        },  
        {
          id: 2,
          name: "Maria Lopez",
          description: "Tired of Online Dating? Let’s Be Each Other’s Reason for Signing Off",
          age: 24,
          image: "https://images.unsplash.com/photo-1545912193-31ce2f0e9a08?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fGNvYXR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
        },
        {
          id: 3,
          name: "Andrew Smith",
          description: "Book Worm Looking to Write the Next Chapter",
          age: 32,
          image: "https://images.unsplash.com/photo-1611485988300-b7530defb8e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8Y29hdHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=800&q=60"
        },
        {
          id: 4,
          name: "Olivia Lee",
          description: "Life is Great, But Maybe It Can Be Better With You?",
          age: 26,
          image: "https://images.unsplash.com/photo-1574108233389-8ac5db89e3f5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OTV8fGNvYXR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
        },
        {
          id: 5,
          name: "Mike Spector",
          description: "Music Lover Looking to Write the Next Verse",
          age: 31,
          image: "https://images.unsplash.com/photo-1608236415053-3691791bbffe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8ODd8fGNvYXR8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
        }
      ]
      
      
